// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: OpenSans;
    font-weight: 500;
}

body p {
    font-family: OpenSans;
    font-weight: 500;
}

body a {
    font-family: OpenSans;
    font-weight: 500;
}

.button {
    letter-spacing: 1.2px;
}
`, "",{"version":3,"sources":["webpack://./src/App/css/custom.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["body {\n    font-family: OpenSans;\n    font-weight: 500;\n}\n\nbody p {\n    font-family: OpenSans;\n    font-weight: 500;\n}\n\nbody a {\n    font-family: OpenSans;\n    font-weight: 500;\n}\n\n.button {\n    letter-spacing: 1.2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
